import posthog from 'posthog-js';

export default {
  install(Vue) {
    // Inicializar PostHog
    posthog.init('phc_kYMKXCuS6fdtStVHRKdk8sBiWAqdASfAjLhPLtL7zqCk', {
      api_host: 'https://us.i.posthog.com',
      person_profiles: 'identified_only',
      capture_pageview: false, // Desabilitar captura automática de pageview
      capture_pageleave: true, // Capturar quando usuário sai da página
      loaded: () => {
        if (process.env.NODE_ENV === 'development') {
          console.log('PostHog inicializado');
        }
      }
    });

    // Adicionar PostHog ao Vue prototype
    Vue.prototype.$posthog = posthog;
  }
};
